import React from 'react';
import Helmet from 'react-helmet';
import SeminarCreateForm from './SeminarCreateForm';

const SeminarCreate = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Seminars Create | ${process.env.REACT_APP_PROJECT_NAME}`}</title>
      </Helmet>

      <SeminarCreateForm />
    </>
  );
};

export default SeminarCreate;
